import { RevxCheckbox, RevxCheckboxProps } from 'components/RevxCheckbox';
import { JobOptionSvc } from 'domains/jobconfigDomain';
import { cloneDeep } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useOneofId } from '../hook/useOneofId';
import { IOneofProps } from '../OneOfSvcs';
import CommonJobSvcImg from './CommonJobSvcImg';

interface Props extends IOneofProps {
  list?: JobOptionSvc[];
  disabled?: boolean;
  value?: number;
  onChange?: (value: number) => void;
  isBundling?: boolean;
}

const CommonOneofFormCheckbox = (props: Props) => {
  const { value, onChange, list, disabled, form, formCache, svcGroup } = props;

  const id = useOneofId(props);

  const [curValue, setCurValue] = useState<(string | number)[]>([value || '']);

  useEffect(() => {
    // controlled mode
    if (value !== undefined) {
      setCurValue([value]);
    }
  }, [value, list]);

  const CommonOneofCheckboxRender = (): RevxCheckboxProps => {
    return {
      maxLength: 1,
      disabled,
      hidden: disabled,
      iconSequence: 'last',
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
        },
      },
      inSideRevxLayoutProps: {
        direction: 'column',
        align: 'center',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        list?.map((svc) => {
          return {
            value: svc.id,
            children: (
              <>
                <CommonJobSvcImg {...svc} isOneOf />
                <span style={{ padding: '10px 0px' }}>{svc.name}</span>
              </>
            ),
          };
        }) || [],
    };
  };

  return (
    <>
      <RevxCheckbox
        {...CommonOneofCheckboxRender()}
        value={curValue}
        onChange={(val: (string | number)[]) => {
          // if (value === undefined) {
          //   // uncontroled mode
          setCurValue(val);
          const formCacheClone = cloneDeep(formCache || {});
          if (val[0]) {
            formCacheClone[id]['name'] = svcGroup?.svcs[0]?.typeName;
          } else {
            formCacheClone[id]['name'] = undefined;
          }
          // }
          if (onChange) {
            form?.setFieldsValue(formCacheClone);
            onChange(+val[0]);
          }
        }}
      />
    </>
  );
};

export default CommonOneofFormCheckbox;
